import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1557618172549922');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1557618172549922&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>
      <div className="min-h-screen bg-brand-beige text-brand-ink overflow-x-hidden flex flex-col items-center" data-id="element-2">
        <div className="w-full max-w-3xl bg-brand-beige shadow-2xl min-h-screen flex flex-col" data-id="element-3">
          <UrgencyBanner data-id="element-4" />
          <Hero data-id="element-5" />
          <PainSection data-id="element-6" />
          <ModulesSection data-id="element-7" />
          <BonusSection data-id="element-8" />
          <PricingCard data-id="element-9" />
          <Guarantee data-id="element-10" />
          <Testimonials data-id="element-11" />
          <FAQ data-id="element-12" />
          <FinalCTA data-id="element-13" />
          <Footer data-id="element-14" />
        </div>
      </div>
    </>;
}